export default __webpack_public_path__ + "media/images/features/toyono/train-3499a67fd178c415e29d3f577d13e49a.png";